import { useFormContext } from 'react-hook-form';
import { lt, useLocalizeCurrency } from '@mews/framework';
import { Stack, Typography } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { getBasePriceFieldName } from '../formEnums';

interface Props {
    defaultCurrencyCode: string;
    id: string;
    name: string;
}

export const PropertyNameCell = ({ defaultCurrencyCode, id, name }: Props) => {
    const { getValues } = useFormContext();
    const localizedCurrency = useLocalizeCurrency();

    const basePrice = getValues(getBasePriceFieldName(id)) || 0;

    return (
        <Stack vertical>
            {name}
            <Typography textStyle="bodySmall" variant="tertiary" as="div">
                {lt('BasePriceExcludeTax')}
                {UnicodeEntity.Colon}
                {UnicodeEntity.Space}
                {localizedCurrency(basePrice, defaultCurrencyCode)}
            </Typography>
        </Stack>
    );
};
